import { CellData, DataMap } from '@ddt-web/data-service';

export class SearchKeywordUtil {
	public static searchByKeyword(searchText: string, rows: DataMap<CellData>[], columnName: string, isModelLevel = false): DataMap<CellData>[] {
		if (!searchText) {
			return rows;
		}

		searchText = searchText.toLowerCase();

		const result = rows.filter((row: DataMap<CellData>) => {
			if ((row?.[columnName]?.rawValue as string).toLowerCase().includes(searchText)) {
				return true;
			} else if (isModelLevel) {
				const filteredRows = (row.portfolios?.rawValue as Array<any>)?.filter(modelRow => modelRow[columnName].toLowerCase().includes(searchText));
				if (filteredRows.length) {
					return row;
				}
			}
		});
		return result;
	}
}
